import { SinclairCalculator } from "/src/components/sinclair";
import * as React from 'react';
export default {
  SinclairCalculator,
  React
};